import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import AboutUs from "../component/pages/landingpage/About";
import Falcon360 from "../component/pages/landingpage/Falcon360";
import TaskStreamAI from "../component/pages/landingpage/Codecheetah";
import OwlsightComponent from "../component/pages/landingpage/Owl";
import BlueGeckoFalcon360HR from "../component/pages/landingpage/Hr";
import BlueGeckoFalcon360 from "../component/pages/landingpage/Manufacturing";
import BlueGeckoFalcon360Logistics from "../component/pages/landingpage/Logistics";

const Auth = () => {
  const location = useLocation();

  // Define valid paths
  const validPaths = ["/login", "/about", "/falcon", "/cheetah", "/owl","/hr","/manufacturing", "/logistics"];

  // Check if current path is valid
  const isValidPath = validPaths.includes(location.pathname);

  // If path is invalid, redirect to login
  if (!isValidPath && location.pathname !== "/") {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
        {/* <Route
          path="/login"
          element={<Login setIsAuthenticated={setIsAuthenticated} />}
        /> */}
        <Route path="/about" element={<AboutUs />} />
        <Route path="/falcon" element={<Falcon360 />} />
        <Route path="/cheetah" element={<TaskStreamAI />} />
        <Route path="/owl" element={<OwlsightComponent />} />
        <Route path="/hr" element={<BlueGeckoFalcon360HR/>}/>
        <Route path="/manufacturing"element={<BlueGeckoFalcon360/>}/>
        <Route path="logistics"element={<BlueGeckoFalcon360Logistics/>}/>
        {/* Catch all invalid paths and redirect to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
  );
};

export default Auth;
